import * as THREE from 'three'
import Experience from '../Experience.js'

export default class Floor
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        this.setGeometry()
        this.setTextures()
        this.setMaterial()
        this.setMesh()
        this.setShadowMesh()
    }

    setGeometry()
    {
        this.geometry = new THREE.PlaneGeometry(5, 5, 20)
    }

    setTextures()
    {
        this.textures = {}

        this.textures.color = this.resources.items.marioColorTexture
        this.textures.color.colorSpace = THREE.SRGBColorSpace
        this.textures.normal = this.resources.items.marioNormalTexture
        this.textures.alpha = this.resources.items.marioAlphaTexture
        this.textures.simpleShadow = this.resources.items.marioShadowTexture
    }

    setMaterial()
    {
        this.material = new THREE.MeshStandardMaterial({
            map: this.textures.color,
            normalMap: this.textures.normal,
            alphaMap: this.textures.alpha,
            transparent: true
        })

        this.shadowsMaterial = new THREE.MeshBasicMaterial({
            color: 'black',
            transparent: true,
            opacity: 0.8,
            alphaMap: this.textures.simpleShadow
        })
  
    }

    setMesh()
    {
        this.mesh = new THREE.Mesh(this.geometry, this.material)
        this.mesh.scale.set(0.25, 0.25, 0.25)
        // this.mesh.geometry.center()
        this.mesh.position.set(0.3, 0.7, 0)
        // this.mesh.rotation.x = - Math.PI * 0.5
        this.mesh.receiveShadow = true
        this.scene.add(this.mesh)
    }

    setShadowMesh()
    {
        this.shadowMesh = new THREE.Mesh(
            new THREE.PlaneGeometry(1, 1, 4),
            this.shadowsMaterial
        )
        this.shadowMesh.scale.set(0.5, 1, 0.5)
        this.shadowMesh.position.y = this.experience.world.floor.mesh.position.y + 0.01
        this.shadowMesh.rotation.x = -Math.PI * 0.5
        this.scene.add(this.shadowMesh)
    }

    update(time)
    {
        this.mesh.position.y = THREE.MathUtils.mapLinear(Math.sin(time.elapsed * 0.01), -1, 1, 0.7, 1.2)

        // modify opacity of the shadow based on the sphere Y position
        this.shadowMesh.material.opacity = THREE.MathUtils.mapLinear(this.mesh.position.y, 0.7, 1.2, 0.7, 0.1)
    }
}